import { defineRouting } from 'next-intl/routing'

export const routing = defineRouting({
  locales: ['tr', 'en'],
  defaultLocale: 'tr',
  localePrefix: 'always',
  pathnames: {
    '/': '/',
    '/market/[id]': {
      tr: '/piyasa/[id]',
      en: '/market/[id]',
    },
    '/exchange/[micCode]': {
      tr: '/borsa/[micCode]',
      en: '/exchange/[micCode]',
    },
    '/stock/[symbol]': {
      tr: '/hisse/[symbol]',
      en: '/stock/[symbol]',
    },
    '/us-stock/[symbol]': {
      tr: '/us-hisse/[symbol]',
      en: '/us-stock/[symbol]',
    },
    '/eu-stock/[symbol]': {
      tr: '/eu-hisse/[symbol]',
      en: '/eu-stock/[symbol]',
    },
    '/jp-stock/[symbol]': {
      tr: '/jp-hisse/[symbol]',
      en: '/jp-stock/[symbol]',
    },
    '/hk-stock/[symbol]': {
      tr: '/hk-hisse/[symbol]',
      en: '/hk-stock/[symbol]',
    },
    '/kr-stock/[symbol]': {
      tr: '/kr-hisse/[symbol]',
      en: '/kr-stock/[symbol]',
    },
    '/in-stock/[symbol]': {
      tr: '/in-hisse/[symbol]',
      en: '/in-stock/[symbol]',
    },
    '/stocks': {
      tr: '/hisseler',
      en: '/stocks',
    },
    '/brokers': {
      tr: '/araci-kurumlar',
      en: '/brokers',
    },
    '/forex/[pair]': {
      tr: '/doviz/[pair]',
      en: '/forex/[pair]',
    },
    '/crypto': {
      tr: '/kripto',
      en: '/crypto',
    },
    '/crypto/[symbol]': {
      tr: '/kripto/[symbol]',
      en: '/crypto/[symbol]',
    },
    '/news': {
      tr: '/haberler',
      en: '/news',
    },
    '/news/[slug]': {
      tr: '/haber/[slug]',
      en: '/news/[slug]',
    },
    // Haber kategorileri GERÇEK rotadır, query filtresi değil. `?kategori=ekonomi`
    // kendi canonical'ını alamıyor, /tr/haberler'e katlanıyordu → yinelenen içerik
    // sayılıp dizine girmiyordu. Her kategori artık kendi URL'i, kendi başlık/
    // açıklaması ve kendi canonical'ı ile ayrı bir sayfa.
    '/news/category/[category]': {
      tr: '/haberler/kategori/[category]',
      en: '/news/category/[category]',
    },
    '/about': {
      tr: '/hakkimizda',
      en: '/about',
    },
    '/contact': {
      tr: '/iletisim',
      en: '/contact',
    },
    '/privacy': {
      tr: '/gizlilik-politikasi',
      en: '/privacy',
    },
    '/terms': {
      tr: '/kullanim-kosullari',
      en: '/terms',
    },
    '/guides': {
      tr: '/rehber',
      en: '/guides',
    },
    '/guides/[slug]': {
      tr: '/rehber/[slug]',
      en: '/guides/[slug]',
    },
  },
})

export type Pathnames = keyof typeof routing.pathnames
export type Locale = (typeof routing.locales)[number]
